import { useTranslation } from 'react-i18next'
import { ISideBarModel, VisiblePlan } from '../../../types/CalendarType'
import DateUtil from 'utils/DateUtil'
import './office-plan/OfficePlanSideBar.scss'

// assets
import OptionIcon from 'assets/icons/options.png'
import locationMarkerGray from 'assets/icons/location-marker-gray.svg'
import binaGray from 'assets/icons/bina-gray.svg'
import listView from 'assets/icons/list-branch.svg'
import avatar from 'assets/icons/avatar.svg'
import masaGray from 'assets/icons/masa-gray.svg'
import homeImg from 'assets/icons/home-gray.svg'

export default function CampusPlanSideBar(props: { model: ISideBarModel }) {
  let dayListElements: JSX.Element[] = []
  const { t } = useTranslation()

  /* Sidebar Info Render View */
  const getSideBarInfoRender = () => {
    var value = props.model

    dayListElements.push(
      <div style={{ borderBottom: '2px solid #dedede' }} key={value.day.date.toString()}>
        <div className="of-plandate">
          <p className="text-center font-bold fs-6">
            <>{DateUtil.dateFormat(value.day?.date) + ' - ' + DateUtil.formatDayofWeek(value.day?.date)}</>
          </p>
        </div>
      </div>
    )

    if (value?.event?.planType === VisiblePlan.HOME_PLAN) {
      dayListElements.push(
        <div className="m-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={value.day.date.toString()}>
          <div className="of-plandate of-plandate-label mt-1">
            <strong>
              {DateUtil.dateFormat(value.event?.reservationDate) + ' - ' + DateUtil.formatDayofWeek(value.day?.date)}
            </strong>
            <div className="of-label of-work-remote ">
              <span>{t('plantype.work-from-remote-label')}</span>
              <img alt="remote" src={homeImg} />
            </div>
          </div>
          <div className="of-plandate mt-2">
            <p>
              <i className="pi pi-home mx-2" style={{ color: '#BFBFBF' }}></i>
              <span>{t('most-used-words.location')}: </span>
              {value.event.locationName === null ? t('dashboard.remote-office-notification') : value.event.locationName}
            </p>
            {value.event.remoteOfficeType !== null && value.event.remoteOfficeType !== '' ? (
              <p>
                <img src={OptionIcon} className="mx-1" width={'25px'} alt="remote-plan-icon" />
                <span>{t('input-texts.remote-office-type')}: </span>
                {value.event.remoteOfficeType}
              </p>
            ) : null}
          </div>
        </div>
      )
    } else if (value?.event?.planType === VisiblePlan.OFFICE_PLAN) {
      dayListElements.push(
        <div className="my-2 mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={value.day.date.toString()}>
          <div className="of-plandate of-plandate-label mt-1">
            <strong>
              {DateUtil.dateFormat(value.event?.reservationDate) + ' - ' + DateUtil.formatDayofWeek(value.day?.date)}
            </strong>
            <div className="of-label of-work-office ">
              <span>{t('plantype.work-from-office-label')}</span>
              <img alt="" />
            </div>
          </div>
          <div className="of-plandate mt-2">
            <p>
              <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
              <span> {t('most-used-words.location')}: </span>{' '}
              {value.event?.locationFirmName + ', ' + value.event?.locationName}
            </p>
          </div>
          <div className="d-flex of-plan-location-block">
            <img src={binaGray} alt="" />
            <p>
              <span>{t('most-used-words.block')}: </span>
              {value.event?.blockName}
              <br />
              <span>{t('most-used-words.floor')}: </span>
              {value.event?.floorName}
            </p>
          </div>
          <div className="of-plandate">
            <div className="d-flex w-100 align-items-center justify-content-between">
              <div>
                <p>
                  <img className="of-office-plan-icon" src={masaGray} alt="" />
                  <span>{t('calendar.table-no')}: </span> {value.event?.tableNum}
                </p>
              </div>
              <button
                className="my-2"
                style={{ background: 'transparent', color: '#333', textDecoration: 'underline', border: 'none' }}>
                {t('buttons.go-to-tableplan')}
              </button>
            </div>
          </div>
        </div>
      )
    } else if (value?.event?.planType === VisiblePlan.COMMON_PLAN) {
      dayListElements.push(
        <div className="my-2 mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={value.day.date.toString()}>
          <div className="of-plandate of-plandate-label mt-1">
            <strong>
              {DateUtil.dateFormat(value.event?.reservationDate) + ' - ' + DateUtil.formatDayofWeek(value.day?.date)}\n            </strong>
            <div className="of-label of-shared-office ">
              <span>{t('plantype.work-from-shared-label')}</span>
              <img alt="" />
            </div>
          </div>
          <div className="of-plandate mt-2">
            <p>
              <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
              <span> {t('most-used-words.location')}: </span>{' '}
              {value.event?.locationFirmName + ', ' + value.event?.locationName}
            </p>
          </div>
          <div className="d-flex of-plan-location-block">
            <img src={binaGray} alt="" />
            <p>
              <span>{t('most-used-words.block')}: </span>
              {value.event?.blockName}
              <br />
              <span>{t('most-used-words.floor')}: </span>
              {value.event?.floorName}
            </p>
          </div>
          <div className="of-plandate">
            <p>
              <img className="of-office-plan-icon" src={masaGray} alt="" />
              <span>{t('calendar.table-no')}: </span> {t('sidebar.table-without-choice')}.
            </p>
          </div>
        </div>
      )
    }

    /* Doctor Appointments */
    value.event?.doctorReservation?.forEach((f) => {
      dayListElements.push(
        <div className="my-2 mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
          <div className="of-plandate of-plandate-label mt-1">
            <strong>{f.reservationStartHourStr + ' - ' + f.reservationEndHourStr}</strong>
            <div className="of-label of-campus-health">
              <span>{t('plantype.campus-health-label')}</span>
              <img alt="" />
            </div>
          </div>

          <div className="of-plandate mb-4">
            <p>
              <div className="of-campus-doctor-icon"></div>
              <span> {t('appointment-modal.doctor-name')}: </span> {f.title + '  ' + f.name + ' ' + f.surname}
            </p>
          </div>
          <div className="d-flex align-items-center of-plan-location-block">
            <img src={listView} alt="" />
            <p>
              <span>{t('appointment-modal.doctor-specialty')}: </span>
              {f.specialty}
            </p>
          </div>
          <div className="of-plandate">
            <p>
              <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
              <span> {t('most-used-words.location')}: </span> {f.locationName}
            </p>
          </div>
          <div className="d-flex of-plan-location-block">
            <img src={binaGray} alt="" />
            <p>
              <span>{t('most-used-words.block')}: </span>
              {f.blockName}
              <br />
              <span>{t('most-used-words.floor')}: </span>
              {f.floorName}
            </p>
          </div>
        </div>
      )
    })
    /* Coiffeur Reservations */
    value.event?.coiffeurReservation?.forEach((f) => {
      dayListElements.push(
        <div className="my-2 mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
          <div className="of-plandate of-plandate-label mt-1">
            <strong>{f.reservationStartHourStr + ' - ' + f.reservationEndHourStr}</strong>
            <div className="of-label of-campus-coiffeur">
              <span>{t('plantype.campus-coiffeur-label')}</span>
              <img alt="" />
            </div>
          </div>

          <div className="of-plandate mb-3">
            <div className="d-flex align-items-center ">
              <div className="of-campus-coiffeur-icon"></div>
              <span> {t('coiffeur-res-modal.coiffeur-name')}: </span> {` ${f.fullName}`}
            </div>
          </div>
          <div className="of-plandate">
            <p>
              <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
              <span> {t('most-used-words.location')}: </span> {f.locationName}
            </p>
          </div>
          <div className="d-flex of-plan-location-block">
            <img src={binaGray} alt="" />
            <p>
              <span>{t('most-used-words.block')}: </span>
              {f.blockName}
              <br />
              <span>{t('most-used-words.floor')}: </span>
              {f.floorName}
            </p>
          </div>
        </div>
      )
    })
    /* Gym Salon Reservations */
    value.event?.gymSaloonReservation?.forEach((f: any) => {
      dayListElements.push(
        <div className="my-2 mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
          <div className="of-plandate of-plandate-label mt-1">
            <strong>
              {f.reservationStartHourStr + ' - ' + f.reservationEndHourStr} | {t('gym-res-modal.personal-res')}
            </strong>
            <div className="of-label of-campus-gym">
              <span>{t('plantype.campus-gym-salon-label')}</span>
              <img alt="" />
            </div>
          </div>

          <div className="of-plandate mb-3">
            <div className="d-flex align-items-center">
              <div className="of-campus-gym-icon"></div>
              <span> {t('gym-res-modal.salon-name')}:</span>&nbsp;{f.gymSaloonName}
            </div>
          </div>

          <div className="of-plandate">
            <p>
              <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
              <span> {t('most-used-words.location')}: </span> {f.locationName}
            </p>
          </div>
          <div className="d-flex of-plan-location-block">
            <img src={binaGray} alt="" />
            <p>
              <span>{t('most-used-words.block')}: </span>
              {f.blockName}
              <br />
              <span>{t('most-used-words.floor')}: </span>
              {f.floorName}
            </p>
          </div>
        </div>
      )
    })
    /* Gym Group Lesson Reservations */
    value.event?.gymGroupLessonReservation?.forEach((f: any) => {
      dayListElements.push(
        <div className="my-2 mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
          <div className="of-plandate of-plandate-label mt-1">
            <strong>
              {f.reservationStartHourStr + ' - ' + f.reservationEndHourStr} | {t('gym-res-modal.lesson-name')}
            </strong>
            <div className="of-label of-campus-gym">
              <span>{t('plantype.campus-gym-salon-label')}</span>
              <img alt="" />
            </div>
          </div>

          <div className="of-plandate mb-3">
            <div className="d-flex align-items-center">
              <div className="of-campus-gym-icon"></div>
              <span> {t('gym-res-modal.salon-name')}:</span>&nbsp;{f.gymSaloonName}
            </div>
          </div>
          <div className="d-flex align-items-center of-plan-location-block">
            <img src={listView} alt="" />
            <p>
              <span>{t('gym-res-modal.lesson-name')}: </span>
              {f.gymLessonTypeName}
            </p>
          </div>
          <div className="of-plandate">
            <p>
              <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
              <span> {t('most-used-words.location')}: </span> {f.locationName}
            </p>
          </div>
          <div className="d-flex of-plan-location-block">
            <img src={binaGray} alt="" />
            <p>
              <span>{t('most-used-words.block')}: </span>
              {f.blockName}
              <br />
              <span>{t('most-used-words.floor')}: </span>
              {f.floorName}
            </p>
          </div>
        </div>
      )
    })
    /* Gym Trainer Reservations */
    value.event?.gymTrainerReservation?.forEach((f: any) => {
      dayListElements.push(
        <div className="my-2 mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
          <div className="of-plandate of-plandate-label mt-1">
            <strong>
              {f.ReservationStartHourStr + ' - ' + f.ReservationEndHourStr} | {t('gym-res-modal.trainer-res')}
            </strong>
            <div className="of-label of-campus-gym">
              <span>{t('plantype.campus-gym-salon-label')}</span>
              <img alt="" />
            </div>
          </div>

          <div className="of-plandate mb-3">
            <div className="d-flex align-items-center">
              <div className="of-campus-gym-icon"></div>
              <span> {t('gym-res-modal.salon-name')}:</span>
              &nbsp;{f.gymSaloonName}
            </div>
          </div>
          <div className="d-flex align-items-center of-plan-location-block">
            <img src={avatar} alt="" />
            <p>
              <span>{t('gym-res-modal.trainer-name')}: </span>
              {f.gymTrainerFullName}
            </p>
          </div>
          <div className="of-plandate">
            <p>
              <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
              <span> {t('most-used-words.location')}: </span> {f.locationName}
            </p>
          </div>
          <div className="d-flex of-plan-location-block">
            <img src={binaGray} alt="" />
            <p>
              <span>{t('most-used-words.block')}: </span>
              {f.blockName}
              <br />
              <span>{t('most-used-words.floor')}: </span>
              {f.floorName}
            </p>
          </div>
        </div>
      )
    })
    /* Lactation Room Reservations */
    value.event?.lactationReservation?.forEach((f: any) => {
      dayListElements.push(
        <div className="my-2 mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
          <div className="of-plandate of-plandate-label mt-1">
            <strong>{f.reservationStartHourStr + ' - ' + f.reservationEndHourStr}</strong>
            <div className="of-label of-campus-lactation">
              <span>{t('plantype.campus-lactationRoom')}</span>
              <img alt="" />
            </div>
          </div>

          <div className="of-plandate mb-3">
            <div className="d-flex align-items-center">
              <div className="of-campus-lactation-icon"></div>
              <span> {t('lactation-res-modal.room-name')}:</span>&nbsp;{f.lactationRoomName}
            </div>
          </div>

          <div className="of-plandate">
            <p>
              <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
              <span> {t('most-used-words.location')}: </span> {f.locationName}
            </p>
          </div>
          <div className="d-flex of-plan-location-block">
            <img src={binaGray} alt="" />
            <p>
              <span>{t('most-used-words.block')}: </span>
              {f.blockName}
              <br />
              <span>{t('most-used-words.floor')}: </span>
              {f.floorName}
            </p>
          </div>
        </div>
      )
    })
    /* Meeting Room Reservations */
    value.event?.meetingRoomReservation?.forEach((f: any) => {
      dayListElements.push(
        <div className="mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
          <div className="of-plandate of-plandate-label mt-1">
            <strong>{f.reservationStartHourStr + ' - ' + f.reservationEndHourStr}</strong>
            <div className="of-label of-campus-meeting">
              <span>{t('plantype.campus-meetingRoom')}</span>
              <img alt="" />
            </div>
          </div>

          <div className="of-plandate mb-3">
            <div className="d-flex align-items-center">
              <div className="of-campus-meeting-icon"></div>
              <span> {t('meeting-res-modal.room-name')}:</span>&nbsp;{f.meetingRoomName}
            </div>
          </div>

          <div className="of-plandate">
            <p>
              <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
              <span> {t('most-used-words.location')}: </span> {f.locationName}
            </p>
          </div>
          <div className="d-flex of-plan-location-block">
            <img src={binaGray} alt="" />
            <p>
              <span>{t('most-used-words.block')}: </span>
              {f.blockName}
              <br />
              <span>{t('most-used-words.floor')}: </span>
              {f.floorName}
            </p>
          </div>
          <div className="of-plandate">
            <p>
              <i className="pi pi-users of-office-plan-icon" color="#A8A8A8" />
              {/* <img className="of-office-plan-icon" src={locationMarkerGray} alt="" /> */}
              <span> {f.capacity}</span>
            </p>
          </div>
        </div>
      )
    })
    /* Pool Vehicle Reservations */
    value.event?.poolVehicleReservation?.forEach((f: any) => {
      dayListElements.push(
        <div className="mx-2 p-2" style={{ borderBottom: '2px solid #dedede' }} key={f.id.toString()}>
          <div className="of-plandate of-plandate-label mt-1">
            <strong>{f.reservationStartHourStr + ' - ' + f.reservationEndHourStr}</strong>
            <div className="of-label of-campus-pool">
              <span>{t('plantype.campus-poolVehicle')}</span>
              <img alt="" />
            </div>
          </div>

          <div className="of-plandate mb-3">
            <div className="d-flex align-items-center">
              <div className="of-campus-pool-icon"></div>
              <span> {t('pool-vehicle-res-modal.brand-model')}:</span>&nbsp;{' '}
              {`${f.poolVehicleBrand} - ${f.poolVehicleModel}`}
            </div>
          </div>

          <div className="of-plandate">
            <p>
              <img className="of-office-plan-icon" src={locationMarkerGray} alt="" />
              <span> {t('most-used-words.location')}: </span> {f.locationName}
            </p>
          </div>
          <div className="d-flex of-plan-location-block">
            <img src={binaGray} alt="" />
            <p>
              <span>{t('pool-vehicle-res-modal.location-to-receive')}: </span>
              {f.locationToReceive}
              <br />
              <span>{t('pool-vehicle-res-modal.location-to-deliver')}: </span>
              {f.locationToDeliver}
            </p>
          </div>
          <div className="of-plandate">
            <p>
              <div className="of-campus-pool-icon"></div>
              <span> {t('pool-vehicle-res-modal.license-plate')}: </span> {f.poolVehiclePlate}
            </p>
          </div>
        </div>
      )
    })

    return dayListElements
  }

  return (
    <div className="of-office-sidebar-container multiple">
      <div className="text-center">
        <p className="of-sidebar-header">{t('tabs.on-campus-services')}</p>
        <p className="of-sidebar-description">{t('sidebar.campus-res-info')}</p>
      </div>

      <hr />

      <div className="multiple-sidebar-info">{getSideBarInfoRender()}</div>
    </div>
  )
}
